'use client'

import { useTranslation } from '../../hooks/useTranslation';
import CarComponent from '../../components/CarComponent'

export const revalidate = 30;

export default function PopularCars({ homeData }) {
  const { t } = useTranslation();

  const cars = homeData?.cars;

  const handleCallClick = () => {
        window.location.href = `/cars`;
    };
  return (
    <section className="py-8 sm:py-12 md:py-16 lg:py-20 bg-[var(--background)]">
      <div className="mx-auto px-4 sm:px-6 md:px-8 lg:px-16 xl:px-24 2xl:px-32">
        {/* Section header */}
        <div className="mb-8 sm:mb-10 md:mb-12">
          <div className="flex items-center mb-3 sm:mb-4">
            <div className="w-8 sm:w-10 md:w-20 h-0.5 bg-[#006FFF] mr-3 sm:mr-4"></div>
            <h2 className="text-2xl sm:text-3xl font-bold font-poppins font-medium not-italic text-[32px] leading-[100%] tracking-[0] text-center">{t('popular.title')}</h2>
          </div>
          <p className="text-white max-w-md text-sm leading-relaxed">
            {t('popular.desc')}
          </p>
        </div>


        {/* Cars grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 lg:gap-4 xl:gap-1 gap-2 sm:mb-2">
          {cars.map((car, index) => (
            <CarComponent key={index} car={car} />
          ))}
        </div>

        {/* View all button */}
        <div className="text-center mt-12">
          <button onClick={handleCallClick} className="bg-blue-600 text-white px-8 py-3 rounded-full hover:bg-blue-700 transition-colors font-semibold inline-flex items-center">
            {t('viewAll')}
          </button>
        </div>
      </div>
    </section>
  )
}
